export class GetCloudResourceSecurityPropertiesResponse {
    'securityProperties';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "securityProperties",
            "baseName": "securityProperties",
            "type": "CloudResourceSecurityProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetCloudResourceSecurityPropertiesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
